import { useState, useRef, useMemo } from 'preact/hooks'
import clsx from 'clsx'
import useClickOutSide from 'hooks/useClickOutSide'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { addClass, removeClass, select } from 'helpers/dom'
import { useEffect } from 'react'

const selectors = {
  PREFIX_PRICE: '.js-prefix-price',
  HIDDEN_CLASS: 'hidden'
}

function CustomSelector({
  value = '',
  options,
  onChange,
  className = '',
  classInput = '',
  classLabel = '',
  placeholder = 'Select Option'
}) {
  const [isActive, setIsActive] = useState(false)
  const [isError, setIsError] = useState(false)
  const prefixPrice = select(selectors.PREFIX_PRICE)
  const refSelector = useRef(null)

  const selected = useMemo(() => {
    const optionSelected = options.filter((option) => option.value === value)

    return optionSelected.length ? optionSelected[0].name : placeholder
  }, [value])

  const changeValue = (newValue) => {
    onChange(newValue)
    setIsActive(false)
  }

  const handleClickOutSide = () => {
    setIsActive(false)
  }

  useClickOutSide(refSelector, handleClickOutSide)

  useEffect(() => {
    if (prefixPrice) {
      if (!value) {
        removeClass(selectors.HIDDEN_CLASS, prefixPrice)
      } else {
        addClass(selectors.HIDDEN_CLASS, prefixPrice)
      }
    }

    if (value) setIsError(false)

    const handleAddToCartError = () => setIsError(!value)

    globalEmitter.on(emitterProps.product.addToCartError, handleAddToCartError)

    return () => {
      globalEmitter.off(emitterProps.product.addToCartError, handleAddToCartError)
    }
  }, [value])

  if (!options?.length) return null

  return (
    <>
      <div ref={refSelector} className="js-custom-selector relative">
        <button
          type="button"
          className={clsx('select-dropdown relative text-left', className, isActive && 'is-active', isError ? 'is-invalid' : '')}
          onClick={() => setIsActive(!isActive)}
        >
          <span className={`input-label ${classLabel}`}>{placeholder}</span>
          <span className={clsx('input', classInput, isError ? 'is-invalid !text-error-700' : '')}>{selected}</span>
        </button>
        {isActive && (
          <div className="dropdown-wrapper is-open">
            <ul className="dropdown-items">
              {options.map((option) => (
                <li key={option.value}>
                  <button
                    type="button"
                    key={option.value}
                    value={option.value}
                    className="item w-full text-left"
                    onClick={() => changeValue(option.value)}
                  >
                    {option.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {isError && <div className="relative pt-2 text-xs text-error-700">{translate.product.pleaseSelectValue}</div>}
    </>
  )
}

export default CustomSelector
